/* eslint-disable */
import { memo } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Pagination } from '@mui/material';
import { Button, Spin, Space } from 'antd';

const CustomerTable = ({
    data = [],
    page = 1,
    limit = 10,
    totalCount = 0,
    onPageChange,
    onEdit,
    onView,
    onTransfer,
    isLoading = false,
    emptyMessage = 'No Data Available',
    columns = null
}) => {
    if (isLoading) {
        return (
            <Space
                direction="vertical"
                style={{
                    width: '100%',
                    paddingTop: 100
                }}
            >
                <Spin tip="Loading" size="large">
                    <div className="content" />
                </Spin>
            </Space>
        );
    }
    const defaultColumns = [
        { id: 'slNo', label: 'Sl. No', align: 'left' },
        { id: 'customerName', label: 'Customer Name', align: 'left' },
        { id: 'mobileNumber', label: 'Mobile No.', align: 'left' },
        { id: 'actions', label: '', align: 'left' }
    ];

    const tableColumns = columns || defaultColumns;

    const getSerialNumber = (index) => {
        return (page - 1) * limit + index + 1;
    };
    const renderCellContent = (column, row, index) => {
        switch (column.id) {
            case 'slNo':
                return getSerialNumber(index);

            case 'customerName':
                return row?.customerName;

            case 'mobileNumber':
                return row?.mobileNumber;

            case 'actions':
                return (
                    <>
                        {onEdit && (
                            <TableCell align="left">
                                <Button type="primary" variant="contained" size="small" onClick={() => onEdit(row, index)}>
                                    Edit
                                </Button>
                            </TableCell>
                        )}
                        {onView && (
                            <TableCell align="left">
                                <Button type="primary" variant="contained" size="small" onClick={() => onView(row, index)}>
                                    View
                                </Button>
                            </TableCell>
                        )}
                        {onTransfer && (
                            <TableCell align="left">
                                <Button type="primary" variant="contained" size="small" onClick={() => onTransfer(row, index)}>
                                    Transfer
                                </Button>
                            </TableCell>
                        )}
                    </>
                );

            default:
                if (column.render) {
                    return column.render(row, index);
                }
                return row[column.id];
        }
    };

    return (
        <>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="customer table">
                    <TableHead>
                        <TableRow>
                            {tableColumns.map((column) => (
                                <TableCell key={column.id} align={column.align || 'left'}>
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={tableColumns.length} align="center">
                                    {emptyMessage}
                                </TableCell>
                            </TableRow>
                        ) : (
                            data.map((row, index) => (
                                <TableRow key={row?.id || index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    {tableColumns.map((column) => {
                                        if (column.id === 'actions') {
                                            return renderCellContent(column, row, index);
                                        }

                                        return (
                                            <TableCell key={column.id} align={column.align || 'left'}>
                                                {renderCellContent(column, row, index)}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {onPageChange && totalCount > 0 && (
                <Pagination
                    count={Math.ceil(totalCount / limit)}
                    page={page}
                    onChange={onPageChange}
                    color="primary"
                    sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}
                />
            )}
        </>
    );
};

export default memo(CustomerTable);
